// Administration
import Home from '@/modules/admin/views/Home';
import Dashboard from '@/modules/admin/views/Dashboard';
import Profile from '@/modules/admin/views/Profile';
// import Charts from '@/modules/admin/views/Charts';
import AppConfig from '@/modules/admin/views/AppConfig';

import { ROLE_USER, ROLE_ADMIN, ROUTE_LOGIN } from '@/router/default-roles';

export default [
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: {
			requiresAuth: false,
			layout: 'main'
		},
	},
	// Optional: a catch-all redirect for any undefined routes (e.g., a 404 page or redirect to home)
	{
		path: '/:pathMatch(.*)*',
		redirect: '/'
	},
	// {
	// 	path: '/home',
	// 	name: 'home',
	// 	component: Home,
	// 	props: (route) => ({ stripeResponse: route.query.stripeResponse}),
	// 	meta: {
	// 		requiresAuth: true,
	// 		layout: 'main'
	// 	},
	// },
	{
		path: '/dashboard',
		name: 'dashboard',
		component: Dashboard,
		meta: {
			/*permissions: [
				{
					role: ROLE_ADMIN,
					access: false,
					redirect: ROUTE_LOGIN,
				},
			],*/
			requiresAuth: true,
			layout: 'main'
		},
	},
	{
		path: '/profile',
		name: 'profile',
		component: Profile,
		meta: {
			permissions: [
				{
					role: ROLE_USER,
					access: (user, to) => user.uid === to.params.uid,
					redirect: ROUTE_LOGIN,
				},
			],
			requiresAuth: true,
			layout: 'main',
		},
	},
	// {
	// 	path: '/charts',
	// 	name: 'charts',
	// 	component: Charts,
	// 	meta: {
	// 		requiresAuth: true,
	// 		layout: 'main',
	// 	},
	// },
	{
		path: '/appconfig',
		name: 'appconfig',
		component: AppConfig,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	
]